// Imports from external sources
// React, i18next, Router, Mantine, Further Stuff
import { 
    Route,
    Routes
} from "react-router-dom"

// Imports from vseth-canine-ui


// Imports from this projects
// Pages, Components, Features, Hooks
import { 
    OrganisationPlacesPage 
} from "../../pages/places/OrganisationPlacesPage"

import {
    CreatePlacePage
} from "../../pages/places/CreatePlacePage"

import { 
    UpdatePlacePage
} from "../../pages/places/UpdatePlacePage"

import { 
    DeletePlacePage
} from "../../pages/places/DeletePlacePage"

import { 
    ViewPlacePage 
} from "../../pages/places/ViewPlacePage"


export const OrganisationsRoutesPlaces = () => {
    return (
        <Routes>
            <Route
                index
                element={<OrganisationPlacesPage/>}                                                                    
            />            
            <Route
                path="create"
                element={<CreatePlacePage/>}                            
            />
            <Route
                path="view"
                element={<ViewPlacePage/>}                            
            />
            <Route
                path="update"
                element={<UpdatePlacePage/>}                            
            />
            <Route
                path="delete"
                element={<DeletePlacePage/>}                            
            />                
        </Routes>     
    )
}  
